import React, { useState } from 'react';

// 더미 데이터
const dummySettlements = [
    {
        id: 1,
        period: '2025년 1월',
        totalRevenue: 14355000,
        commission: 1435500,
        settlementAmount: 12919500,
        status: '정산 완료',
        settlementDate: '2025-02-05',
        details: [
            { product: '연기 기초 마스터 클래스', sales: 25, revenue: 2475000 },
            { product: 'K-pop 댄스 비디오 강의', sales: 18, revenue: 1422000 },
            { product: '보컬 트레이닝 패키지', sales: 9, revenue: 1341000 }
        ]
    },
    {
        id: 2,
        period: '2024년 12월',
        totalRevenue: 12800000,
        commission: 1280000,
        settlementAmount: 11520000,
        status: '정산 완료',
        settlementDate: '2025-01-05',
        details: [
            { product: '연기 기초 마스터 클래스', sales: 22, revenue: 2178000 },
            { product: 'K-pop 댄스 비디오 강의', sales: 16, revenue: 1264000 },
            { product: '보컬 트레이닝 패키지', sales: 8, revenue: 1192000 }
        ]
    },
    {
        id: 3,
        period: '2024년 11월',
        totalRevenue: 11200000,
        commission: 1120000,
        settlementAmount: 10080000,
        status: '정산 완료',
        settlementDate: '2024-12-05',
        details: [
            { product: '연기 기초 마스터 클래스', sales: 20, revenue: 1980000 },
            { product: 'K-pop 댄스 비디오 강의', sales: 14, revenue: 1106000 },
            { product: '보컬 트레이닝 패키지', sales: 7, revenue: 1043000 }
        ]
    }
];

const pendingSettlement = {
    period: '2025년 2월 (예정)',
    totalRevenue: 8500000,
    commission: 850000,
    settlementAmount: 7650000,
    status: '정산 예정',
    settlementDate: '2025-03-05',
    details: [
        { product: '연기 기초 마스터 클래스', sales: 15, revenue: 1485000 },
        { product: 'K-pop 댄스 비디오 강의', sales: 10, revenue: 790000 },
        { product: '보컬 트레이닝 패키지', sales: 5, revenue: 745000 }
    ]
};

const KoachSalesSettlement = () => {
    const [settlements] = useState(dummySettlements);
    const [expandedId, setExpandedId] = useState<number | null>(null);

    const toggleExpand = (id: number) => {
        setExpandedId(expandedId === id ? null : id);
    };

    return (
        <div className="min-h-screen bg-gray-50 pt-20 pb-4 px-4">
            <div className="max-w-6xl mx-auto">
                <h1 className="text-2xl font-bold text-gray-900 mb-6">정산</h1>

                {/* 정산 예정 카드 */}
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6 border-2 border-[#CF3688]">
                    <div className="flex justify-between items-start mb-4">
                        <div>
                            <h2 className="text-lg font-semibold text-gray-900 mb-2">{pendingSettlement.period}</h2>
                            <p className="text-sm text-gray-600">정산 예정일: {pendingSettlement.settlementDate}</p>
                        </div>
                        <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                            {pendingSettlement.status}
                        </span>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                        <div>
                            <p className="text-sm text-gray-600 mb-1">총 매출</p>
                            <p className="text-xl font-bold text-gray-900">
                                {pendingSettlement.totalRevenue.toLocaleString()}원
                            </p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-600 mb-1">수수료 (10%)</p>
                            <p className="text-xl font-bold text-gray-600">
                                -{pendingSettlement.commission.toLocaleString()}원
                            </p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-600 mb-1">정산 금액</p>
                            <p className="text-xl font-bold text-[#CF3688]">
                                {pendingSettlement.settlementAmount.toLocaleString()}원
                            </p>
                        </div>
                    </div>
                </div>

                {/* 정산 내역 */}
                <div className="space-y-4">
                    <h2 className="text-lg font-semibold text-gray-900">정산 내역</h2>
                    {settlements.map((settlement) => (
                        <div key={settlement.id} className="bg-white rounded-lg shadow-sm overflow-hidden">
                            <div 
                                className="p-6 cursor-pointer hover:bg-gray-50 transition-colors"
                                onClick={() => toggleExpand(settlement.id)}
                            >
                                <div className="flex justify-between items-start mb-4">
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900 mb-1">
                                            {settlement.period}
                                        </h3>
                                        <p className="text-sm text-gray-600">
                                            정산일: {settlement.settlementDate}
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-4">
                                        <div className="text-right">
                                            <p className="text-sm text-gray-600">정산 금액</p>
                                            <p className="text-lg font-bold text-[#CF3688]">
                                                {settlement.settlementAmount.toLocaleString()}원
                                            </p>
                                        </div>
                                        <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">
                                            {settlement.status}
                                        </span>
                                        <button className="text-gray-400 hover:text-gray-600">
                                            {expandedId === settlement.id ? '▼' : '▶'}
                                        </button>
                                    </div>
                                </div>
                                
                                {expandedId === settlement.id && (
                                    <div className="mt-4 pt-4 border-t border-gray-200">
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                            <div>
                                                <p className="text-sm text-gray-600 mb-1">총 매출</p>
                                                <p className="text-lg font-semibold text-gray-900">
                                                    {settlement.totalRevenue.toLocaleString()}원
                                                </p>
                                            </div>
                                            <div>
                                                <p className="text-sm text-gray-600 mb-1">수수료 (10%)</p>
                                                <p className="text-lg font-semibold text-gray-600">
                                                    -{settlement.commission.toLocaleString()}원
                                                </p>
                                            </div>
                                            <div>
                                                <p className="text-sm text-gray-600 mb-1">정산 금액</p>
                                                <p className="text-lg font-semibold text-[#CF3688]">
                                                    {settlement.settlementAmount.toLocaleString()}원
                                                </p>
                                            </div>
                                        </div>
                                        
                                        <div className="mt-4">
                                            <p className="text-sm font-medium text-gray-700 mb-2">상세 내역</p>
                                            <div className="space-y-2">
                                                {settlement.details.map((detail, idx) => (
                                                    <div key={idx} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                                                        <div>
                                                            <p className="text-sm font-medium text-gray-900">{detail.product}</p>
                                                            <p className="text-xs text-gray-500">판매량: {detail.sales}개</p>
                                                        </div>
                                                        <p className="text-sm font-semibold text-gray-900">
                                                            {detail.revenue.toLocaleString()}원
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default KoachSalesSettlement;

